import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const OrderSuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [orderId, setOrderId] = useState(null);
  const [animationStage, setAnimationStage] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('orderId');
    if (id) {
      setOrderId(id);
    }
    
    // Check mobile
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Animate elements in sequence
    const timers = [];
    timers.push(setTimeout(() => setAnimationStage(1), 100));
    timers.push(setTimeout(() => setAnimationStage(2), 400));
    timers.push(setTimeout(() => setAnimationStage(3), 700));
    
    return () => {
      timers.forEach(timer => clearTimeout(timer));
      window.removeEventListener('resize', checkMobile);
    };
  }, [location]);

  return (
    <>
      <Header />
      
      <div style={{
        minHeight: 'calc(100vh - 200px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 24px',
        background: '#fff'
      }}>
        <div style={{
          maxWidth: '600px',
          width: '100%',
          textAlign: 'center'
        }}>
          {/* Success Icon */}
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 40px',
            border: '2px solid #181818',
            borderRadius: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fff',
            opacity: animationStage >= 1 ? 1 : 0,
            transform: animationStage >= 1 ? 'scale(1)' : 'scale(0.8)',
            transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
          }}>
            <span style={{
              fontSize: '40px',
              fontWeight: '300',
              color: '#181818'
            }}>
              ✓
            </span>
          </div>
          
          {/* Main Content */}
          <div style={{
            opacity: animationStage >= 2 ? 1 : 0,
            transform: animationStage >= 2 ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s ease'
          }}>
            <h1 style={{
              fontSize: '36px',
              fontWeight: '600',
              margin: '0 0 16px 0',
              color: '#181818',
              textTransform: 'uppercase',
              letterSpacing: '3px'
            }}>
              Order Placed
            </h1>
            
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              margin: '0 0 32px 0',
              maxWidth: '400px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              Thank you for your order. We'll send you a confirmation via WhatsApp shortly.
            </p>
            
            {orderId && (
              <div style={{
                display: 'inline-block',
                padding: '24px 48px',
                background: '#fff',
                border: '1px solid #e8e8e8',
                marginBottom: '48px'
              }}>
                <div style={{
                  fontSize: '12px',
                  color: '#888',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  marginBottom: '8px'
                }}>
                  Order Reference
                </div>
                <div style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#181818',
                  letterSpacing: '2px',
                  fontFamily: 'monospace'
                }}>
                  {orderId.slice(-8).toUpperCase()}
                </div>
              </div>
            )}
          </div>
          
          {/* Next Steps */}
          <div style={{
            opacity: animationStage >= 3 ? 1 : 0,
            transform: animationStage >= 3 ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s ease'
          }}>
            <div style={{
              padding: '32px',
              background: '#f8f8f8',
              border: '1px solid #e8e8e8',
              marginBottom: '40px'
            }}>
              <h3 style={{
                fontSize: '14px',
                fontWeight: '600',
                margin: '0 0 20px 0',
                color: '#181818',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                What Happens Next
              </h3>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                gap: '24px',
                textAlign: 'center'
              }}>
                <div>
                  <div style={{
                    fontSize: '24px',
                    fontWeight: '300',
                    color: '#888',
                    marginBottom: '8px'
                  }}>
                    1
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#666',
                    lineHeight: '1.4'
                  }}>
                    Order confirmation via WhatsApp
                  </div>
                </div>
                
                <div>
                  <div style={{
                    fontSize: '24px',
                    fontWeight: '300',
                    color: '#888',
                    marginBottom: '8px'
                  }}>
                    2
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#666',
                    lineHeight: '1.4'
                  }}>
                    Preparation begins
                  </div>
                </div>
                
                <div>
                  <div style={{
                    fontSize: '24px',
                    fontWeight: '300',
                    color: '#888',
                    marginBottom: '8px'
                  }}>
                    3
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#666',
                    lineHeight: '1.4'
                  }}>
                    Delivery or pickup ready
                  </div>
                </div>
              </div>
            </div>
            
            {/* Action Button */}
            <div style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <button 
                onClick={() => navigate('/catalogue')}
                style={{
                  padding: '16px 48px',
                  background: '#333',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '0',
                  fontSize: '14px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.background = '#000'}
                onMouseOut={(e) => e.target.style.background = '#333'}
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default OrderSuccessPage;